/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/root.reducers';
import { Caret } from '../../common';
import { InteractiveComponents } from '../../../core/enums/InteractiveComponents';

import './SettingsVideoWindowInteractiveLayer.scss';

const SettingsVideoWindowInteractiveLayer: FunctionComponent = (): JSX.Element => {
    const activeComponent = useSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );
    return (
        <React.Fragment>
            <Caret
                direction={InteractiveComponents.WEST}
                active={activeComponent === InteractiveComponents.WEST}
                className={'settings-video-window-caret-west'}
                visible={true}
            />
            <Caret
                direction={InteractiveComponents.EAST}
                active={activeComponent === InteractiveComponents.EAST}
                className={'settings-video-window-caret-east'}
                visible={true}
            />
        </React.Fragment>
    );
};

export default SettingsVideoWindowInteractiveLayer;
